<template>
  <Modal :title="formData.id ? '编辑' : '新增'" v-model="visible" width="800" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <div class="page-form">
      <Form :model="formData" ref="formValidate" class="page-form less" :label-width="100">
        <FormItem class="half" label="姓名" prop="checkDate">
          {{ formData.name }}
        </FormItem>
        <FormItem class="half" label="工号" prop="staffNo">
          {{ formData.staffNo }}
        </FormItem>
        <FormItem class="half" label="入职时间" prop="entryTime">
          {{ formData.entryTime | filterTime('YYYY-MM-DD') }}
        </FormItem>
        <FormItem class="half" label="核算时间" prop="checkDate" :rules="$units.formRule.objRequired('请选择核算时间')">
          <DatePicker v-model="formData.checkDate" transfer type="date" value-format="yyyy-MM-dd" placeholder="请选择核算时间" />
        </FormItem>
        <FormItem class="half flex" label="考核时间" prop="year" :rules="$units.formRule.objRequired('请选择考核时间')">
          <DatePicker v-model="formData.year" transfer type="year" placeholder="请选择考核时间" />
          <Select style="margin-left: 10px" transfer v-model="formData.quarter" :options="quarterList" placeholder="请选择季度">
            <Option v-for="item in quarterList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem class="half" label="保费金额" prop="fee">
          <Input v-model="formData.fee" placeholder="请输入保费金额">
            <template #append>
              <span>美元</span>
            </template>
          </Input>
        </FormItem>
        <FormItem class="half" label="是否active" prop="activeStatus" :rules="$units.formRule.required('请选择是否active')">
          <RadioGroup v-model="formData.activeStatus">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </div>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>
  </Modal>
</template>
  <script>
import dayjs from 'dayjs';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  props: {},
  data() {
    return {
      options: {
        disabledDate(date) {
          return Number(dayjs(date).format('MM')) % 3 != 1;
        }
      },
      visible: false,
      quarterList: [
        {
          label: '第一季度',
          value: 1
        },
        {
          label: '第二季度',
          value: 2
        },
        {
          label: '第三季度',
          value: 3
        },
        {
          label: '第四季度',
          value: 4
        }
      ],
      orgUserList: [],
      formData: {
        id: '',
        checkDate: '',
        fee: '',
        activeStatus: '',
        year: '',
        quarter: 1
      }
    };
  },

  methods: {
    save() {
      this.$refs.formValidate.validate().then(isok => {
        console.log(isok);
        if (!isok) {
          return;
        }
        let formData = {
          ...this.formData,
          checkDate: dayjs(this.formData.checkDate).format('YYYY-MM-DD'),
          year: dayjs(this.formData.year).format('YYYY')
        };
        this.$http({
          url: this.formData.id ? '/buz/userActiveRecord/edit' : '/buz/userActiveRecord/add',
          type: 'POST',
          data: formData
        })
          .then(res => {
            this.$notice.msg('操作成功');
            this.visible = false;
            this.$emit('success');
          })
          .catch(err => {
            console.error(err);
            this.$notice.msg('操作失败');
          });
      });
    },
    open(data) {
      console.log(data);
      if (data.id) {
        this.$http({
          url: '/buz/userActiveRecord/read/detail',
          type: 'GET',
          data: {
            id: data.id
          }
        }).then(res => {
          if(res.data.year){
            res.data.year = dayjs(res.data.year + '-01-01').format('YYYY-01-01');
          }
          this.formData = res.data;
        });
      } else {
        this.formData = {
          id: '',
          checkDate: '',
          fee: '',
          activeStatus: '',
          year: '',
          quarter: 1,
          ...data
        };
      }
      this.visible = true;
      this.$refs.formValidate && this.$refs.formValidate.resetFields();
    }
  }
};
</script>
  <style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}
.half {
  width: 50%;
}
/deep/.flex {
  .ivu-form-item-content {
    display: flex;
  }
}
</style>
  